var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.list, function (item) {
        return _c(
          "el-col",
          { key: item.id, attrs: { span: 6 } },
          [
            _c(
              "el-card",
              {
                staticClass: "projectCard",
                attrs: {
                  "body-style": {
                    background:
                      _vm.type.type == 3
                        ? "rgba(" + _vm.rgbaFn(_vm.type.color) + ",0.1)"
                        : "",
                  },
                },
              },
              [
                item.bidSectionCode
                  ? _c(
                      "div",
                      {
                        staticClass: "clearfix",
                        style: {
                          background:
                            "rgba(" + _vm.rgbaFn(_vm.type.color) + ",0.2)",
                          padding: "9px",
                        },
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("img", { attrs: { src: _vm.type.imgUrl, alt: "" } }),
                        _c("span", { staticClass: "card_title" }, [
                          _vm._v(_vm._s(item.bidSectionCode)),
                        ]),
                        _c("div", { staticClass: "header_img" }, [
                          item.historyid == -1
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/images/fixed.png"),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                          item.historyid == 0
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/images/status_processed.png"),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                          item.historyid == 1
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/images/status_ignore.png"),
                                  alt: "",
                                },
                              })
                            : _vm._e(),
                        ]),
                        _c("div", { staticClass: "header_img1" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/images/status_bg.png"),
                              alt: "",
                            },
                          }),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "text item" }, [
                  _c("div", [
                    _c("img", { attrs: { src: item.imgUrl, alt: "" } }),
                  ]),
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "card_text" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "dark",
                              content: item.bidSectionName,
                              placement: "right",
                            },
                          },
                          [
                            _c("div", { staticClass: "card_texts" }, [
                              _vm._v(_vm._s(item.bidSectionName)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "card_cont",
                        staticStyle: { display: "flex" },
                      },
                      [
                        _c("span", { staticClass: "card_cont_span" }, [
                          _vm._v("预警内容"),
                        ]),
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "tooltipItem",
                            attrs: {
                              effect: "dark",
                              content: item.warnContent,
                              placement: "right",
                            },
                          },
                          [_c("div", [_vm._v(_vm._s(item.warnContent))])]
                        ),
                        _vm._v("  : " + _vm._s(item.actualValue) + " "),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "card_cont" }, [
                      _c("span", { staticClass: "card_cont_span" }, [
                        _vm._v("预警时间"),
                      ]),
                      _vm._v(" " + _vm._s(item.warnTime) + " "),
                    ]),
                    _c("div", { staticClass: "card_cont" }, [
                      _c("span", { staticClass: "card_cont_span" }, [
                        _vm._v("发生场地"),
                      ]),
                      _vm._v(" " + _vm._s(item.warnPlace) + " "),
                    ]),
                  ]),
                ]),
                !item.code
                  ? _c(
                      "div",
                      { staticClass: "card-btn" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(item.id)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        item.historyid == -1
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.dealDetail(item)
                                  },
                                },
                              },
                              [_vm._v("忽略")]
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ],
          1
        )
      }),
      _vm.page.total - Number(_vm.list.length) > 0
        ? [
            _c("el-col", { attrs: { span: 6 } }, [
              _c("div", { staticClass: "more", on: { click: _vm.moreData } }, [
                _c("span", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.page.total >= Number(_vm.list.length) + 7
                          ? "加载更多"
                          : `加载剩余 ${
                              _vm.page.total - Number(_vm.list.length)
                            } 条`
                      ) +
                      " "
                  ),
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/right_circle.png"),
                      alt: "",
                    },
                  }),
                ]),
              ]),
            ]),
          ]
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "处理意见",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialogBox" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: "200",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.auditForm.opinion,
                  callback: function ($$v) {
                    _vm.$set(_vm.auditForm, "opinion", $$v)
                  },
                  expression: "auditForm.opinion",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handle()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "backBtn",
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }